import { BusinessPlanSurveyExample } from '../types';

export const SurveySectionExamples = (props: { examples: BusinessPlanSurveyExample[] }) => {
  const { examples } = props;
  return (
    <div className="survey-section__examples">
      {examples.map((x, i) => (
        <div className="survey-section__example" key={`example-${i + 1}-${x.header}`}>
          <div className="survey-section__example-header">{x.header}</div>
          <div className="survey-section__example-text">{x.content}</div>
        </div>
      ))}
    </div>
  );
};
